const roundedToCents = amt => {
  return Number((Math.round(amt * 100) / 100).toFixed(2));
};

module.exports = roundedToCents;
